import { render, staticRenderFns } from "./OutagesResults.vue?vue&type=template&id=ed79b7d0"
import script from "./OutagesResults.vue?vue&type=script&lang=js"
export * from "./OutagesResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports